import { t } from '@lingui/macro'
import { useFeatureFlagsQuery } from './useFeatureFlags.codegen'

/**
 * keep in mind most of our feature flags only affect frontend
 */
export function useFeatureFlags() {
  const { data, refetch, loading } = useFeatureFlagsQuery({
    fetchPolicy: 'cache-first'
  })

  return {
    loadingFeatureFlags: loading,
    featureFlags: data?.organisation.features,
    refetchFeatureFlags: refetch
  }
}

export const useCPDFeatureFlag = () => {
  const { featureFlags } = useFeatureFlags()

  return {
    cpdAlias: t`CPD`,
    isCPDEnabledInAccountSettings:
      featureFlags?.cpd?.switched_on === true &&
      featureFlags?.cpd?.enabled === true
  }
}
